export default {
  state: {
    models: [
      {
        type: 'sweatshirts', // тип изделия
        model: 'svitshot', // УНИКАЛЬНОЕ, модель
        title: 'Свитшот Премиум', // заголовок
        description: `<p>Толстовка без капюшона (свитшот) прямого силуэта. Манжеты внизу и на рукавах, вырез горловины круглый, рибана.</p>
        <p><strong>Стиль:</strong> Унисекс. Толстовка подходит для мужчин и для женщин.</p>
        <p><strong>Состав: </strong>80% ХБ, 20% ПЭ, футер трехнитка с начесом.</p>
        <p><strong>Плотность:&nbsp;</strong>330гр/м2</p>
        <p><strong>Размеры: </strong>S, M, L, XL, XXL, 3XL</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'red', 'melange', 'gray', 'blue', 'dark-blue', 'white'], // доступные цвета
        defaultColor: 'red',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/07/switshot.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-3-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/krasniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/krasniy-2-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/melange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/melange-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-3-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-2-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-3-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/beliy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/beliy-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 2, price: 1100 },
          {from: 3, to: 5, price: 990 },
          {from: 6, to: 10, price: 890 },
          {from: 11, to: 20, price: 800 },
          {from: 21, to: 50, price: 750 },
          {from: 51, to: 100, price: 680 },
          {from: 101, to: 250, price: 620 },
          {from: 251, to: 500, price: 550 },
          {from: 501, to: 1000, price: 530 },
          {from: 1001, to: 3000, price: 520 },
        ]
      },
      {
        type: 'sweatshirts', // тип изделия
        model: 'svitshot-standart', // УНИКАЛЬНОЕ, модель
        title: 'Свитшот мужской Стандарт', // заголовок
        description: `<p>Легкая толстовка-свитшот, с манжетами на поясе и рукавах. Мягкий начес с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 14 цветах – вы точно подберете тон под ваш фирменный стиль.<br>
        <strong>Плотность:</strong> 200-220 г/м2;<br>
        <strong>Состав:</strong> 100% хлопок высшего качества;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с начесом<br>
        <strong>Размеры:</strong> XS, M, L, XL, XXL, 3XL;<br>
        <strong>Воротник:</strong> круглый — О-ворот с добавлением лайкры и мягким компенсатором горловины,<br>
        <strong>Рукав:</strong> втачной;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение:</strong> активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'cyan', 'green', 'red', 'melange', 'menthol', 'orange',
          'sand', 'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'blue',
        image: 'https://pr-tex.ru/wp-content/uploads/siniy-4.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-5.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-5-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/bordo-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/bordo-2-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/giluboy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/giluboy-1-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/green-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/green-1-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/red-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/red-2-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-5.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-5-100x100.jpg',
          },
          {
            color: 'menthol',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/myata001.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/myata001-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/empty-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/empty-1-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/pesok-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/pesok-1-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-seruy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-seruy-1-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy-4-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-6-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/beliy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/beliy-2-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/yellow-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/yellow-4-100x100.jpg',
          },
        ],
        sizes: ['xs', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 5, price: 1200 },
          {from: 6, to: 10, price: 990 },
          {from: 11, to: 20, price: 850 },
          {from: 21, to: 30, price: 750 },
          {from: 31, to: 50, price: 700 },
          {from: 51, to: 100, price: 650 },
          {from: 101, to: 250, price: 600 },
          {from: 251, to: 500, price: 570 },
          {from: 501, to: 1000, price: 550 },
          {from: 1001, to: 3000, price: 530 },
          {from: 3001, to: 99999, price: 510 },
        ]
      },
      {
        type: 'sweatshirts', // тип изделия
        model: 'svitshot-zhenskij', // УНИКАЛЬНОЕ, модель
        title: 'Свитшот Женский', // заголовок+
        description: `<p>Легкая приталенная модель свитшота с манжетами на поясе и рукавах. Мягкий начес с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 14 цветах – вы точно подберете тон под ваш фирменный стиль.<br>
        <strong>Плотность:</strong> 200-220 г/м2;<br>
        <strong>Состав:</strong> 100% хлопок высшего качества;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с начесом<br>
        <strong>Размеры:</strong>&nbsp;S, M, L, XL, XXL;<br>
        <strong>Воротник:</strong> круглый — О-ворот с добавлением лайкры и мягким компенсатором горловины,</p>
        <p><strong>Рукав:</strong> реглан;<br>
        <strong>Силуэт:</strong>&nbsp;приталенный;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;<br>
        <strong>Марка:</strong>&nbsp;PR-Tex Classic.</p>`,
        gender: 'female', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['fuchsia', 'cyan', 'melange', 'orange', 'sand', 'gray', 'blue', 'lilac',
          'white', 'yellow'], // доступные цвета
        defaultColor: 'fuchsia',
        image: 'https://pr-tex.ru/wp-content/uploads/img_6222-1.jpg',
        slides: [
          {
            color: 'fuchsia',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6222-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6222-1-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6226.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6226-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6241.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6241-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6230.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6230-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6255.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6255-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6235.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6235-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6268.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6268-100x100.jpg',
          },
          {
            color: 'lilac',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6248.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6248-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6261.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6261-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6211.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6211-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 800 },
          {from: 11, to: 30, price: 700 },
          {from: 31, to: 50, price: 650 },
          {from: 51, to: 100, price: 600 },
          {from: 101, to: 250, price: 550 },
          {from: 251, to: 500, price: 500 },
          {from: 501, to: 1000, price: 470 },
          {from: 1001, to: 3000, price: 450 },
          {from: 3001, to: 100000, price: 430 },
        ]
      },
      {
        type: 'sweatshirts', // тип изделия
        model: 'svitshot-detskij', // УНИКАЛЬНОЕ, модель
        title: 'Свитшот детский', // заголовок
        description: `<p>Детская модель свитшота, с манжетами на поясе и рукавах. Мягкий начес с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 14 цветах – вы точно подберете тон под ваш фирменный стиль.<br>
        <strong>Плотность:</strong> 200-220 г/м2;<br>
        <strong>Состав:</strong> 100% хлопок высшего качества;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с начесом<br>
        <strong>Размеры:</strong>&nbsp;28 – 40;<br>
        <strong>Воротник:</strong> круглый — О-ворот с добавлением лайкры и мягким компенсатором горловины,</p>
        <p><strong>Крой:</strong> прямой<br>
        <strong>Рукав:</strong> втачной;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение:</strong> активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'children', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['fuchsia', 'azure', 'melange', 'menthol', 'orange', 'sand', 'gray', 'blue',
          'lilac', 'white', 'yellow'], // доступные цвета
        defaultColor: 'menthol',
        image: 'https://pr-tex.ru/wp-content/uploads/img_6313.jpg',
        slides: [
          {
            color: 'fuchsia',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6285.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6285-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6317.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6317-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6304.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6304-100x100.jpg',
          },
          {
            color: 'menthol',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6313.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6313-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6272.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6272-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6310.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6310-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6291.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6291-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6320.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6320-100x100.jpg',
          },
          {
            color: 'lilac',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6288.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6288-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6275.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6275-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/img_6297.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/img_6297-100x100.jpg',
          },
        ],
        sizes: ['28', '32', '36', '40'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 800 },
          {from: 11, to: 30, price: 700 },
          {from: 31, to: 50, price: 620 },
          {from: 51, to: 100, price: 560 },
          {from: 101, to: 250, price: 510 },
          {from: 251, to: 500, price: 470 },
          {from: 501, to: 1000, price: 450 },
          {from: 1001, to: 3000, price: 430 },
          {from: 3001, to: 100000, price: 399 },
        ]
      },
      {
        type: 'sweatshirts', // тип изделия
        model: 'tolstovka', // УНИКАЛЬНОЕ, модель
        title: 'Толстовка', // заголовок
        description: `<p>Легкая толстовка-свитшот, с манжетами на поясе рукавах. Мягкий начес с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 14 цветах – вы точно подберете тон под ваш фирменный стиль.</p>
        <p><strong>Плотность</strong>: 200-260 г/м2;<br>
        <strong>Состав</strong>: 100% хлопок высшего качества;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с начесом<br>
        <strong>Размеры:</strong> XS, M, L, XL, XXL, 3XL;<br>
        <strong>Воротник:</strong> круглый — О-ворот с добавлением лайкры и мягким компенсатором горловины,<br>
        <strong>Рукав:</strong> втачной;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение</strong>: активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex&nbsp; Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'red', 'melange', 'gray', 'blue', 'dark-blue', 'white'], // доступные цвета
        defaultColor: 'red',
        image: 'https://pr-tex.ru/wp-content/uploads/red-1.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-4-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/red-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/red-1-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-4-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-seruy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-seruy-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy-3-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-5.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-5-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/beliy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/beliy-1-100x100.jpg',
          },
        ],
        sizes: ['xs', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 800 },
          {from: 11, to: 50, price: 650 },
          {from: 51, to: 100, price: 500 },
          {from: 101, to: 250, price: 450 },
          {from: 251, to: 500, price: 420 },
          {from: 501, to: 1000, price: 400 },
          {from: 1001, to: 3000, price: 380 },
        ]
      },
    ]
  }
}